import MarkdownIt from 'markdown-it'
import Prism from 'prismjs'

import { getSiteURL, joinURLPath } from '@sigma-frontend-libs/commons'
import { NOTIFICATIONS_AVAILABLE_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import { proxy } from '@/utils'

import render from './render'

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,

  highlight(code, lang) {
    const source = Prism.highlight(code, Prism.languages[lang] || Prism.languages.markup, lang)

    return `<pre class="language-${lang || 'markup'}"><code class="language-${lang || 'markup'}">${source}</code></pre>`
  }
})
md.linkify.set({ fuzzyLink: true })

export default {
  name: 'NotificationTemplateDialog',

  mixins: [ proxy() ],

  props: {
    data: {
      type: Object,
      default: undefined
    },

    path: String
  },

  data() {
    return {
      loading: false,
      showDialog: false,

      html: undefined
    }
  },

  computed: {
    title() {
      return this.path?.replace('.manager', '')
    },

    channel() {
      let result
      Object.keys(NOTIFICATIONS_AVAILABLE_TYPES).map(type => {
        if (this.path?.includes(type)) {
          result = type
        }
      })

      return result
    }
  },

  mounted() {
    this.getDocument()
  },

  methods: {
    submit() {
      this.$emit('data', this.data)
      this.proxy = false
    },

    async getDocument() {
      if (this.proxy) {
        this.loading = true
        this.html = undefined
        const pathToFile = joinURLPath('docs', this.locale, 'platform', 'administrator', 'settings.md')
        const response = await fetch(getSiteURL(pathToFile), { cache: 'no-cache' })
        if (response.ok) {
          this.html = md.render(await response.text())
        }
        this.loading = false
      }
    }
  },

  render
}
